import DatePickerComponent from 'react-datepicker';
import styled, {css} from 'styled-components';

import {colors} from 'theme';

export const InnerDatePicker = styled(DatePickerComponent)``;

export const DatePickerHead = styled.div`
    margin: 10px;
    display: grid;
    grid-template-columns: auto 1fr 80px auto;
    align-items: center;
    gap: 5px;
`;

export const DatePickerArrow = styled.button<{disabled?: boolean; right?: boolean}>`
    display: flex;
    gap: 5px;
    justify-content: center;
    align-items: center;
    border: 2px solid ${colors.brandPrimary};
    border-radius: 50%;
    width: 25px;
    height: 25px;
    background: ${colors.transparent};
    color: ${colors.brandPrimary};
    cursor: pointer;
    transition: all 0.15s ease-in-out;

    & > * {
        position: relative;
        top: 1px;
        right: 1px;
    }

    ${(p) =>
        p.disabled &&
        css`
            pointer-events: none;
            color: ${colors.textMuted};
            border-color: ${colors.textMuted};
        `}

    ${(p) =>
        p.right &&
        css`
            & > * {
                transform: rotate(180deg);
                right: 0;
            }
        `}
`;
